import Companies from './components/Companies';
export default Companies;